import { render } from "./SelectTraineesModal.vue?vue&type=template&id=89479d58&scoped=true"
import script from "./SelectTraineesModal.vue?vue&type=script&lang=js"
export * from "./SelectTraineesModal.vue?vue&type=script&lang=js"

import "./SelectTraineesModal.vue?vue&type=style&index=0&id=89479d58&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SelectTraineesModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89479d58"]])

export default __exports__